import React from "react";
import { Formik, Field } from "formik";
import {
  FormGroup,
  Page,
  SubmitButton,
  Checkbox,
  Editor,
} from "components/common";
import { useFormHelpers, useAsyncEffect } from "hooks";
import { NotificationManager } from "react-notifications";
import { isInt } from "validator";

export const Form = ({ title }) => {
  return (
    <Page title={title}>
      <FormGroup name="vimeo_video_id" label="Vimeo Video ID">
        <Field name="vimeo_video_id" className="form-control" />
      </FormGroup>
      <FormGroup name="title" label="Title">
        <Field name="title" className="form-control" />
      </FormGroup>
      <FormGroup name="content" label="Content">
        <Field component={Editor} name="content" />
      </FormGroup>
      <FormGroup name="live" label="Live?" check>
        <Field name="live" component={Checkbox} className="form-check-input" />
      </FormGroup>
      <div className="tw-flex tw-justify-end">
        <SubmitButton>Save</SubmitButton>
      </div>
    </Page>
  );
};

export const Edit = () => {
  const {
    validationObject,
    setInitialValues,
    initialValues,
    load,
    save,
    replacePathId,
    pageTitle,
  } = useFormHelpers({ url: "videos", resource: "Video" });

  useAsyncEffect(async () => {
    const initialValues = await load({
      vimeo_video_id: "",
      live: true,
      title: "",
      content: null,
    });
    setInitialValues(initialValues);
  }, []);

  async function onSubmit(x, { setSubmitting }) {
    try {
      const resp = await save(x);
      replacePathId(resp.id);
      NotificationManager.success("Saved successfully");
    } finally {
      setSubmitting(false);
    }
  }

  if (!initialValues) return null;

  return (
    <>
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validationObject({
          vimeo_video_id: (v) => !isInt(v + ""),
        })}
      >
        {(formik) => <Form title={pageTitle} {...formik} />}
      </Formik>
    </>
  );
};

export default Edit;
